// Base styles
import * as tabStatic from "assets/components-static-styles/components/tabs/tab";
import colors from "assets/theme-dark/base/colors";

// Helper functions
import { merge } from "lodash";

const { text } = colors;

// types
type Types = any;

const themeStyles = {
  styleOverrides: {
    root: {
      color: `${text.main}`,
      // color: `${white.main} !important`,
    },
  },
};

const tab: Types = merge(themeStyles, tabStatic.default);

export default tab;
